import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from '@/locales';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, NAMESPACES, type SupportedLanguage } from './constants';

// 重新导出类型和常量，保持向后兼容
export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, NAMESPACES, type SupportedLanguage };

// i18n 配置
export const i18nConfig = {
  // 设置默认语言为中文
  lng: DEFAULT_LANGUAGE as SupportedLanguage,

  // 回退语言
  fallbackLng: DEFAULT_LANGUAGE as SupportedLanguage,

  // 调试模式（关闭调试日志）
  debug: false,

  // 命名空间
  ns: Object.values(NAMESPACES),
  defaultNS: NAMESPACES.WORKFLOW,

  // 语言检测配置
  detection: {
    // 检测顺序 - 优先使用 cookie（服务器端可读），然后 localStorage，最后是默认语言
    order: ['cookie', 'localStorage'],
    // 同时缓存到 cookie 和 localStorage
    caches: ['cookie', 'localStorage'],
    // Cookie 配置
    lookupCookie: 'i18nextLng',
    cookieMinutes: 525600, // 1年（365天 * 24小时 * 60分钟）
    cookieDomain: typeof window !== 'undefined' ? window.location.hostname : undefined,
    cookiePath: '/',
    cookieSecure: typeof window !== 'undefined' ? window.location.protocol === 'https:' : false,
    cookieSameSite: 'lax',
    // LocalStorage 配置
    lookupLocalStorage: 'i18nextLng',
    // 检测失败时使用默认语言
    checkWhitelist: true,
    // 强制使用检测到的语言
    convertDetectedLanguage: (lng: string) => {
      // 如果检测到不支持的语言，返回默认语言
      return ['zh', 'en'].includes(lng) ? lng : DEFAULT_LANGUAGE;
    },
    // 关闭调试信息
    debug: false,
  },

  // 插值配置
  interpolation: {
    // React 不需要转义
    escapeValue: false,
  },

  // 资源
  resources,

  // 命名空间分隔符
  nsSeparator: ':',

  // 键分隔符
  keySeparator: '.',
};

// 初始化 i18n
export const initI18n = () => {
  // 只在未初始化时才进行初始化
  if (!i18n.isInitialized) {
    // 在初始化前检查 localStorage 中的语言设置
    if (typeof window !== 'undefined') {
      const savedLanguage = localStorage.getItem('i18nextLng');

      // 如果有保存的语言设置，在初始化时使用它
      if (savedLanguage && ['zh', 'en'].includes(savedLanguage)) {
        i18nConfig.lng = savedLanguage as SupportedLanguage;
      }
    }

    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init(i18nConfig);
  }

  return i18n;
};

